module.exports = __webpack_public_path__ + "static/media/pending.77774244.svg";